const state = () => ({
  isValid: false,
  email: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  email(state) {
    return state.email;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateEmail(state, payload) {
    state.email = payload;
  }
};

const actions = {
  updateEmail({ commit }, payload) {
    commit('updateEmail', payload);
  }
};

export const email = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
